import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { RequireRole } from './components/auth/RequireRole';
import { LoginScreen } from './components/auth/LoginScreen';
import { RegisterPage } from './components/auth/RegisterPage';
import { CreateCompanyPage } from './components/auth/CreateCompanyPage';
import { AppLayout } from './components/layout/AppLayout';
import { Dashboard } from './components/admin/Dashboard';
import { SettingsScreen } from './components/admin/SettingsScreen';
import { ProductsManagement } from './components/products/ProductsManagement';
import { AddProductPage } from './components/products/AddProductPage';
import { BatchDetailPage } from './components/products/BatchDetailPage';
import { ProductDetailsPage } from './components/products/ProductDetailsPage';
import { ScanHistory } from './components/scans/ScanHistory';
import { FailedScans } from './components/scans/FailedScans';
import { UsersManagement } from './components/users/UsersManagement';
import { AddOfficerPage } from './components/users/AddOfficerPage';
import { UserDetailsPage } from './components/users/UserDetailsPage';
import { AppStateProvider, useAppState } from './context/AppStateContext';

const AdminLayoutRoute = () => {
  const { handleRefresh } = useAppState();
  return (
    <RequireRole role="Admin">
      <AppLayout onRefresh={handleRefresh} />
    </RequireRole>
  );
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginScreen />} />
    <Route path="/register" element={<RegisterPage />} />
    <Route path="/create-company" element={<CreateCompanyPage />} />

    <Route path="/admin" element={<AdminLayoutRoute />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="users" element={<UsersManagement />} />
      <Route path="users/add-officer" element={<AddOfficerPage />} />
      <Route path="users/:userId" element={<UserDetailsPage />} />
      <Route path="products" element={<ProductsManagement />} />
      <Route path="products/add" element={<AddProductPage />} />
      <Route path="products/batch/:batchNo" element={<BatchDetailPage />} />
      <Route path="products/:productId" element={<ProductDetailsPage />} />
      <Route path="scans" element={<ScanHistory />} />
      <Route path="failed-scans" element={<FailedScans />} />
      <Route path="settings" element={<SettingsScreen />} />
    </Route>

    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

const App = () => (
  <Router>
    <AppStateProvider>
      <AppRoutes />
    </AppStateProvider>
  </Router>
);

export default App;
